<template>
    <div v-show="!isRolled" class="flex flex-col overflow-hidden h-full shrink">
        <div class="main-container">
            <dx-toolbar>
                <dx-item location="after">
                    <DxButton class="ai-button-base" hint="Обновить" @click="async () => await loadNavigatorData()">
                        <component :is="'ai-refresh-base'" />
                    </DxButton>
                </dx-item>
                <dx-item location="after">
                    <DxDropDownButton
                        :dropDownOptions="{ width: 150, height: 160 }"
                        :focusStateEnabled="false"
                        :icon="filterIcon"
                        class="filters_button"
                        hint="Фильтры"
                    >
                        <template #content>
                            <DxList
                                v-model:selected-item-keys="selectedFilters"
                                :data-source="filterOptions"
                                :show-selection-controls="true"
                                display-expr="text"
                                selection-mode="multiple"
                                value-expr="id"
                                @selection-changed="onFiltersChange"
                            >
                                <template #item="{ data, index }">
                                    <div :class="{ separator: index === 3 }">{{ data.text }}</div>
                                </template>
                            </DxList>
                        </template>
                    </DxDropDownButton>
                </dx-item>
                <dx-item location="after">
                    <DxDropDownButton
                        :dropDownOptions="{ width: 150, height: 160 }"
                        :focusStateEnabled="false"
                        :icon="settingsIcon"
                        class="settings_button"
                        hint="Настройки открытия карточек"
                    >
                        <template #content>
                            <DxList
                                :data-source="settingsOptions"
                                :selected-item-keys="selectedSettings"
                                :show-selection-controls="true"
                                display-expr="text"
                                selection-mode="multiple"
                                value-expr="id"
                                @selection-changed="onSettingsChange"
                            />
                        </template>
                    </DxDropDownButton>
                </dx-item>
            </dx-toolbar>

            <DxContextMenu
                ref="contextMenuRef"
                :data-source="contextMenuItems"
                :show-event="{ name: 'dxcontextmenu' }"
                class="menu-points"
                target=".dx-treeview-item"
                @itemClick="onContextMenuItemClick"
                @showing="onContextMenuShowing"
            />

            <DxTreeView
                ref="treeViewRef"
                :animation-enabled="true"
                :data-source="filteredTreeData"
                :root-value="null"
                class="overflow-y-auto"
                data-structure="plain"
                hasItemsExpr="has_items"
                item-template="item"
                key-expr="unique_id"
                parent-id-expr="parent_id_str"
                scroll-direction="vertical"
                width="100%"
                @item-click="onItemClick"
                @item-rendered="onItemRendered"
                @item-context-menu="onItemContextMenu"
            >
                <template #item="{ data }">
                    <div
                        :class="{ 'clicked-node': clickedNodes?.some(node => node['unique_id'] === data['unique_id']) }"
                        :title="data.caption"
                        class="tree-node"
                    >
                        <DxCheckBox
                            :read-only="true"
                            :value="data.selected"
                            :visible="data.type !== 'root'"
                            class="custom-checkbox"
                        />
                        <component :is="data.icon" v-if="data.has_items" class="tree-node-icon" />
                        <span :title="data.caption" class="tree-node-text">
                            {{ data.caption }}
                        </span>
                    </div>
                </template>
            </DxTreeView>
        </div>
    </div>
</template>
<script setup>
import { DxButton, DxCheckBox, DxContextMenu, DxList, DxTreeView } from 'devextreme-vue';
import DxDropDownButton from 'devextreme-vue/drop-down-button';
import { onMounted, ref } from 'vue';
import {
    ContextNames,
    getContextGroup,
    getDefaultContextGroup,
    saveContexts,
} from '@/layouts/main-layout/main-layout-data';
import { getDataSource } from '@/service/meta-service';
import DxToolbar, { DxItem } from 'devextreme-vue/toolbar';
import ArrayStore from 'devextreme/data/array_store';
import { setTabTitle } from '@/layouts/main-layout/components/navigation-bars-data';
import { useRouter } from 'vue-router';
import { getUserSettingsChanges, setUserSettingsChanges } from '@/service/userdata-service';

const orgContextGroup = ref(null);
const treeViewRef = ref();
const treeData = ref([]);
const filteredTreeData = ref([]);
//const searchQuery = ref('');
const contextMenuRef = ref();
const router = useRouter();
const filterOptions = new ArrayStore({
    key: 'id',
    data: [
        {
            id: 2,
            text: 'Новые',
        },
        {
            id: 0,
            text: 'Активные',
        },
        {
            id: 1,
            text: 'Архив',
        },
        {
            id: 3,
            text: 'Точки',
        },
    ],
});
const selectedFilters = ref([2, 0, 3]);
const settingsOptions = new ArrayStore({
    key: 'id',
    data: [
        {
            id: 1,
            text: 'Абонент',
        },
        {
            id: 2,
            text: 'Договор',
        },
        {
            id: 3,
            text: 'Объект',
        },
        {
            id: 4,
            text: 'ТУ',
        },
    ],
});
const contextMenuItems = ref([
    {
        text: 'Установить контекст',
        action: 'setContext',
    },
    {
        text: 'Открыть карточку',
        action: 'openCard',
    },
]);
const selectedSettings = ref([2]);
//let searchTimeout = ref();
const settingsIcon = `<svg width="79" height="79" viewBox="0 0 79 79" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M45.8581 4.08836C42.7691 -0.326979 36.2307 -0.326979 33.1418 4.08836L31.724 6.11496C29.8526 8.78982 26.5073 10.0074 23.3544 9.16124L20.9656 8.52012C15.7612 7.12333 10.7525 11.3261 11.2243 16.694L11.4409 19.1579C11.7267 22.4098 9.94669 25.4929 6.9875 26.8713L4.74549 27.9157C-0.139159 30.191 -1.27454 36.6301 2.53732 40.4388L4.28693 42.187C6.59621 44.4944 7.2144 48.0004 5.83357 50.9584L4.78739 53.1996C2.50808 58.0824 5.77728 63.7448 11.1456 64.2123L13.6096 64.4268C16.8617 64.71 19.5889 66.9984 20.4325 70.152L21.0717 72.5413C22.4642 77.7468 28.6083 79.9831 33.0211 76.8905L35.0466 75.471C37.7199 73.5975 41.28 73.5975 43.9533 75.471L45.9788 76.8905C50.3916 79.9831 56.5357 77.7468 57.9282 72.5413L58.5674 70.152C59.411 66.9984 62.1382 64.71 65.3903 64.4268L67.8543 64.2123C73.2226 63.7448 76.4918 58.0824 74.2125 53.1996L73.1663 50.9584C71.7855 48.0004 72.4037 44.4944 74.713 42.187L76.4626 40.4388C80.2744 36.6301 79.139 30.191 74.2544 27.9157L72.0124 26.8713C69.0532 25.4929 67.2732 22.4098 67.559 19.1579L67.7756 16.694C68.2474 11.3261 63.2387 7.12333 58.0343 8.52012L55.6455 9.16124C52.4926 10.0074 49.1473 8.78982 47.2759 6.11496L45.8581 4.08836ZM39.5 54.9611C47.4867 54.9611 53.9612 48.4866 53.9612 40.4999C53.9612 32.5132 47.4867 26.0386 39.5 26.0386C31.5133 26.0386 25.0388 32.5132 25.0388 40.4999C25.0388 48.4866 31.5133 54.9611 39.5 54.9611Z" fill="#286EB6"/>
</svg>`;

const filterIcon = `<svg width="48" height="48" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="2.5" y="4" width="7.5" height="1" rx="0.5" fill="#286EB6"/>
<rect x="4" y="6" width="4.5" height="1" rx="0.5" fill="#286EB6"/>
<rect x="5" y="8" width="2.5" height="1" rx="0.5" fill="#286EB6"/>
</svg>`;

const clickedNodes = ref([]);
const nodeInContextMenu = ref({});
const args = {
    select: {
        meta_args: {
            select: 'payer.hf_org_navigator_get',
        },
    },
    api: {
        select: 'counteragent./org-context-navigator/get',
    },
};

defineProps({
    isRolled: {
        type: Boolean,
        default: true,
    },
});
const isFirstLoad = ref(true);
const refreshData = async () => {
    //Сюда попадаем только через main-layout-data, когда произошла смена контекста
    orgContextGroup.value = getContextGroup(ContextNames.ORG_CONTEXT_GROUP);
    clickedNodes.value = [];
    treeData.value = [];
    await loadNavigatorData();
    if (!isFirstLoad.value) {
        await openCard();
    }
    isFirstLoad.value = false; // После первой загрузки устанавливаем в false
};
const getResponse = async item => {
    const payload = {
        ...args.select,
        select_args: {
            ...orgContextGroup.value,
            filters: {
                pr_active: selectedFilters.value?.filter(item => item !== 3),
                show_all_tu: selectedFilters.value?.includes(3),
                ...(item && { item }),
            },
        },
    };
    return await getDataSource(args.api.select, payload);
};

const concatData = (item, data) => {
    //Тыкнули на договор/объект+"все ту"
    if (item.parent_id === -2 || (item.parent_id === -3 && selectedFilters.value?.includes(3))) {
        treeData.value = [
            ...treeData.value.filter(node => node?.type === 'root' && node?.id >= item.parent_id),
            ...treeData.value.filter(node => node?.type !== 'root' && node?.parent_id >= item.parent_id),
            ...data,
        ];
    }
};

const loadNavigatorData = async item => {
    //Не обновляем данные, если ткнули узел объект и нет отметки "все ТУ" или узел ТУ
    if (item && ((item.parent_id === -3 && !selectedFilters.value?.includes(3)) || item.parent_id === -4)) {
        return;
    }
    const response = await getResponse(item);
    //если тыкали по узлам, надо только докинуть
    if (item && response.result) {
        concatData(item, response.data);
    } else {
        treeData.value = response.result ? response.data : [];
    }
    applyFilters();
};

const applyFilters = () => {
    /*
    TODO ТУ выставлены по умолчанию и сразу подгружаются.
    если далее их выключить и перезагрузить данные и потом снова включить,
    при установленном контексте на ТУ, подгрузится только ТУ которая в контексте
    */
    let filteredData = treeData.value?.filter(item => {
        if (!item?.parent_id) {
            if (item?.id === -4) {
                //если рутовый узел ТУ, тогда выводим его, если он есть в фильтре
                return selectedFilters.value?.includes(3);
            } else {
                //оставляем все рутовые узлы
                return true;
            }
        } else {
            //для остальных узлов берем совпадение по pr_active
            return selectedFilters.value?.filter(item => item !== 3).includes(item?.pr_active);
        }
    });
    //Для исключения ситуаций, когда контекст задан до уровня ТУ, но объекты в архиве, а ТУ нет, чтобы ТУ в этом случае не отсвечивала
    if (filteredData) {
        const hasChildren = parentId => filteredData.some(item => item?.parent_id === parentId);
        const removeNodeAndChildren = nodeId =>
            (filteredData = filteredData.filter(item => /*item?.id !== nodeId &&*/ item?.parent_id !== nodeId));
        if (!hasChildren(-3)) {
            removeNodeAndChildren(-4);
        }
        if (!hasChildren(-2)) {
            removeNodeAndChildren(-3);
            removeNodeAndChildren(-4);
        }
        filteredTreeData.value = filteredData;
        needConcatData();
    }
};

const needConcatData = () => {
    const getMinParentIdItem = data => {
        const minParentId = Math.min(...data.map(item => item.parent_id));
        const minId = Math.min(...data.filter(item => item.parent_id === null).map(item => item.id));
        if (minId === minParentId) {
            /*например в контексте пришел уровень абонент
            мы загрузили его и его договора
            ставим отметку на первый договор и подгружаем его обекты
            */
            //Уточнение. Если пришли договора, один из который selected, надо выбрать его
            const selectedItem = data.find(item => item.parent_id === minParentId && item.selected);
            if (selectedItem) {
                return selectedItem;
            } else {
                return data.find(item => item.parent_id === minParentId);
            }
        }
    };
    const minParentIdItem = getMinParentIdItem(filteredTreeData.value);
    if (minParentIdItem?.parent_id > -4) {
        //обнуляем на всякий, а то программный вызов может думать, что это даблклик
        lastClickTimeStamp.value = 0;
        //cтавим программно отметку, и подгружаем данные
        onItemClick({ itemData: minParentIdItem });
    }
};

const fillClickedNodes = e => {
    if (!e.itemData.selected) {
        switch (e.itemData.parent_id) {
            case -1:
                clickedNodes.value = [];
                break;
            case -2:
                clickedNodes.value = clickedNodes.value.filter(
                    node => node.parent_id !== -4 && node.parent_id !== -3 && node.parent_id !== -2
                );
                clickedNodes.value.push(e.itemData);
                break;
            case -3:
                clickedNodes.value = clickedNodes.value.filter(node => node.parent_id !== -4 && node.parent_id !== -3);
                clickedNodes.value.push(e.itemData);
                break;
        }
        treeViewRef.value.instance.repaint();
    } else {
        clickedNodes.value = [];
    }
};

const lastClickTimeStamp = ref(0);
let singleClickTimeout = null;
const onItemClick = e => {
    if (e.itemData.parent_id !== null) {
        const currentTime = new Date().getTime();
        const doubleClickDelay = 300;
        console.log(currentTime - lastClickTimeStamp.value);
        if (currentTime - lastClickTimeStamp.value < doubleClickDelay) {
            // Считаем это двойным кликом, отменяем обработку одиночного клика
            clearTimeout(singleClickTimeout);
            onItemDblClick(e);
        } else {
            lastClickTimeStamp.value = currentTime;
            // Запускаем отложенный вызов одиночного клика
            singleClickTimeout = setTimeout(() => {
                fillClickedNodes(e);
                loadNavigatorData(e.itemData);
            }, doubleClickDelay);
        }
    }
};

const onItemDblClick = e => {
    const newContextGroup = getDefaultContextGroup(ContextNames.ORG_CONTEXT_GROUP);
    const { id, caption, parent_id } = e.itemData;
    newContextGroup.contexts.PayerContext = orgContextGroup.value.contexts.PayerContext;
    const findNode = parentId => clickedNodes.value.find(node => node.parent_id === parentId);
    const createContext = node => ({
        value: node.id,
        userText: node.caption,
    });
    switch (parent_id) {
        case -2:
            newContextGroup.contexts.DogContext = createContext({
                id,
                caption,
            });
            break;
        case -3: {
            const clickedDogNode = findNode(-2);
            newContextGroup.contexts.DogContext = clickedDogNode
                ? createContext(clickedDogNode)
                : orgContextGroup.value.contexts.DogContext;
            newContextGroup.contexts.NumObjContext = createContext({
                id,
                caption,
            });
            break;
        }
        case -4: {
            const clickedDogNode = findNode(-2);
            const clickedObjectNode = findNode(-3);
            newContextGroup.contexts.DogContext = clickedDogNode
                ? createContext(clickedDogNode)
                : orgContextGroup.value.contexts.DogContext;
            newContextGroup.contexts.NumObjContext = clickedObjectNode
                ? createContext(clickedObjectNode)
                : orgContextGroup.value.contexts.NumObjContext;
            newContextGroup.contexts.PointContext = createContext({
                id,
                caption,
            });
            break;
        }
    }
    saveContexts({
        nameGroup: ContextNames.ORG_CONTEXT_GROUP,
        value: newContextGroup,
    });
};

const onItemRendered = e => {
    if (e.itemData.parent_id === null) {
        e.itemElement.style.fontWeight = 'bold';
    }
};

const onFiltersChange = () => {
    applyFilters();
};

const onItemContextMenu = e => {
    nodeInContextMenu.value = e.itemData;
};

const onContextMenuShowing = e => {
    if (nodeInContextMenu.value?.type === 'root') {
        e.cancel = true;
    }
};

const onContextMenuItemClick = async e => {
    if (!nodeInContextMenu.value) return;
    if (e.itemData.action === 'setContext') {
        onItemDblClick({ itemData: nodeInContextMenu.value });
    }
    if (e.itemData.action === 'openCard') {
        await openCard(nodeInContextMenu.value);
    }
};

const openCard = async itemData => {
    if (itemData) {
        await navigateToRoute(itemData.caption, itemData.type, itemData.id);
    } else if (selectedSettings.value.length) {
        {
            const contextPriority = [
                {
                    context: 'PointContext',
                    type: 'point',
                    settingId: 4,
                },
                {
                    context: 'NumObjContext',
                    type: 'object',
                    settingId: 3,
                },
                {
                    context: 'DogContext',
                    type: 'dog',
                    settingId: 2,
                },
                {
                    context: 'PayerContext',
                    type: 'payer',
                    settingId: 1,
                },
            ];
            const minLvlContext = contextPriority.find(lvl => orgContextGroup.value.contexts[lvl.context]?.value);
            if (selectedSettings.value.includes(minLvlContext.settingId)) {
                await navigateToRoute(
                    orgContextGroup.value.contexts[minLvlContext.context].userText,
                    minLvlContext.type,
                    orgContextGroup.value.contexts[minLvlContext.context].value
                );
            }
        }
    }
};

const navigateToRoute = async (title, type, id) => {
    setTabTitle(title);
    const routeMap = {
        payer: {
            name: 'counteragent-card-view',
            params: { id },
        },
        dog: {
            name: 'contract-card-view',
            params: { id },
        },
        object: {
            name: 'ObjectCard',
            params: { id },
        },
        //когда то тут будут другие карточки
    };
    if (routeMap[type]) {
        await router.push(routeMap[type]);
    }
};

const onSettingsChange = async e => {
    const newSelection = e.component.option('selectedItemKeys');
    if (JSON.stringify(newSelection) === JSON.stringify(selectedSettings.value)) {
        return;
    }
    selectedSettings.value = newSelection;

    await setUserSettingsChanges({
        viewId: 'org-navigator-view',
        settings: selectedSettings.value,
    });
};

onMounted(async () => {
    const response = await getUserSettingsChanges({ viewId: 'org-navigator-view' });
    if (response.result && response.settings?.length >= 0) {
        selectedSettings.value = response.settings;
    }
});

defineExpose({
    refreshData,
});
</script>
<script>
export default {
    name: 'org-navigator-view',
};
</script>
<style lang="scss" scoped>
:root {
    --main-color: rgb(40 110 182);
}

.filters_button,
.settings_button {
    background-color: transparent;
    border-radius: 1px;
}

.ai-button-base {
    border-radius: 50%;
}

.filters_button :deep(.dx-button),
.settings_button :deep(.dx-button) {
    border-right: none !important;
}

.tree-node {
    display: flex;
    align-items: center;
    gap: 6px;
    padding-left: 4px;
    overflow: hidden;
}

.clicked-node {
    background-color: rgba(193, 223, 255, 1);
    border-bottom: 2px solid rgb(40 110 182);
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
    gap: 8px;
    width: calc(100% + 40px);
    margin-left: -8px;
    padding-left: 10px;
    padding-right: 5px;
}

:deep(.dx-treeview-item) {
    background-color: unset !important;
    padding: 3px 0 3px 0;
    gap: 0;
}

.custom-checkbox {
    background-color: white;
    order: -1;
    flex-shrink: 0;
    border-radius: 4px;
}

.tree-node-icon {
    flex-shrink: 0;
    padding-right: 20px;
}

.tree-node-text {
    flex-grow: 1;
    white-space: nowrap;
    min-width: 0;
    font-family: Golos, GolosText, sans-serif;
    font-size: 14px;
    font-weight: 200;
    line-height: 180%;
    overflow: hidden;
    text-overflow: ellipsis;
}

:deep(.dx-widget.dx-state-readonly.dx-checkbox.custom-checkbox .dx-checkbox-icon) {
    background-color: unset !important;
    border-style: none;
}

:deep(.dx-treeview-toggle-item-visibility) {
    color: rgb(40 110 182);
    font: 25px/1 DXIcons;
}

:deep(.dx-treeview-toggle-item-visibility) {
    width: 15px;
    height: 9px;
    background-repeat: no-repeat;
    background-position: center;
    margin-right: 8px;
}

.main-container {
    border-radius: 8px;
    background-color: rgba(246, 250, 254, 0.6);
    backdrop-filter: blur(23%);
    box-shadow: 0 4px 6px rgba(0, 10, 19, 0.11);
    padding: 5px;
}

.dx-toolbar {
    background: transparent;
}
</style>
